'use strict';
var $ = require('jquery');
var stickyHeader = require('vhi-ui-framework/src/main/js/layout/stickyHeader');

/**
 * Initialises the header state.
 * <p>
 * Takes a promise as argument that return true/false.
 * If the promise resolves to true, the log out CTA is displayed.
 * For all other resolution states the log out CTA in NOT displayed.
 * </p>
 */
function init(isLoggedIn) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);
    showHideLogoutCTA(isLoggedIn);
}

function initWithLoginCta(isLoggedIn, isGroups) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);

    if (isGroups || (!isGroups && isLoggedIn)) {
        var loginButtonTemplate = require('templates/landing/navbarLoginButton.jade');
        var html = loginButtonTemplate({isLoggedIn: isLoggedIn});
        var $placeHolder = $('#login-btn-dynamic-content');
        $placeHolder.html(html);
    }
}

/**
 * Displays or hides the Logout CTA.
 * @param aBoolean if true the Logout CTA is displayed, remains hidden otherwise.
 */
function showHideLogoutCTA(aBoolean){
    if(aBoolean===true){
        $('#nav-logout').show();
    }else{
        $('#nav-logout').hide();
    }
}

module.exports = {
    init: init,
    initWithLoginCta: initWithLoginCta
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/utils/header.js
// module id = iPHx
// module chunks = 0 1 2 3 4 5 6 7 8